import React from 'react';
import {SvgIcon, SvgIconProps} from "@mui/material";

const UndoIconSvg = (<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M7.17482 11.0462L10.181 14.1128L9.37803 14.9334L5 10.4667L9.37576 6L10.1798 6.82055L7.17482 9.88719H13.7538C14.574 9.88719 15.3863 10.0521 16.1441 10.3724C16.9019 10.6928 17.5905 11.1623 18.1705 11.7542C18.7505 12.3461 19.2106 13.0488 19.5245 13.8222C19.8384 14.5956 20 15.4244 20 16.2615V18H18.8643V16.2615C18.8643 15.5766 18.7321 14.8985 18.4753 14.2657C18.2185 13.6329 17.842 13.058 17.3675 12.5737C16.8929 12.0894 16.3295 11.7053 15.7095 11.4432C15.0895 11.1811 14.4249 11.0462 13.7538 11.0462H7.17482Z"
            fill="currentColor"/>
    </svg>

)
const UndoIcon: React.FC<SvgIconProps> = (props) => (
    <SvgIcon {...props}>
        {UndoIconSvg}
    </SvgIcon>
);
export default UndoIcon